import EventManager from "../../../store/sqftEventManager";
import config from "../../../store/sqftConfig";
import {getFontsize, inchesToMm, isDisabledInPopupWithParents, isInnerCorner} from "../../../../../helpers/sqftHelper";
//import shapeHelper from "../../../../../helpers/shapeHelper";
import {isDisabledInPopupShouldBeHidden} from "../../../../../constants";

export default function() {
  var self = this,
    point = null;

  function setPoint(value) { point = value; }

  this.destroy = function(protect) {
    if(!protect) {
      EventManager.removeEvent(self);
    }
  };

  this.init = function(point) {
    setPoint(point);
    this.initEvents();
  };
  this.initEvents = () => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      self.render,
      self,
      EventManager.priorities.OVERLAY
    );
  }
  this.deregisterPartEvents = () => {
    EventManager.removeEvent(this);
  };
  this.reInitPartEvents = () => {
    this.initEvents();
  };
  this.render = (ctx) => {
    if (isDisabledInPopupShouldBeHidden() && isDisabledInPopupWithParents(point)) {
      return
    }

    if (point.arcLength > 0 || point.angle > 0) {
      const line = point.getParent(),
        shape       = line.getParent(),
        //nextLine    = shape.getNextLine(line),
        //nextLineTo  = nextLine.calculateRenderPosition(nextLine.to),
        prevLine  = shape.getPrevLine(line),
        prevLineFrom  = prevLine.calculateRenderPosition(prevLine.from),
        renderTo    = line.calculateRenderPosition(line.to),
        renderFrom  = line.calculateRenderPosition(line.from),
        isInner = isInnerCorner(shape, prevLineFrom, renderFrom, renderTo);

      let fontSize = getFontsize(),
        font = (config.measureUnit === "Imperial" ? fontSize : fontSize - 5).toString() + "px " + config.activeFontBold,
        radius = point.arcLength || point.angle,
        //dir = shape.getAngleDirection(shape.getPrevLine(line)),
        //isInner = shapeHelper.isAngleInner(dir),
        pointCorner = point.corner ? point.corner : isInner,
        cornerMargin = pointCorner
          ? point.arcLength ? +point.arcLength - 8 : +point.angle
          : point.arcLength ? -point.arcLength + 8 : -point.angle,
        radiusLetter = point.arcLength ? "r" : "",
        dstring = config.measureUnit === "Metric"
          ? radiusLetter + new Fraction(inchesToMm(radius)) + "mm"
          : radiusLetter + new Fraction(radius) + "\"",
        mtext = ctx.measureText(dstring),
        tLen = mtext.width,
        offset = point.getPointField(),
        renderPos = {
          x: offset.x + offset.width,
          y: offset.y + (offset.height / 2)
        };
      ctx.beginPath();
      ctx.font = font;
      ctx.textAlign = "center";
      renderPos.y += fontSize / 2;
      // ctx.fillStyle = "rgb(178, 99, 168)";
      // ctx.fillRect(offset.x - 4, offset.y + 2 + (fontSize * 2), tLen + 6, fontSize + 4);
      ctx.beginPath();
      ctx.fillStyle = "#b263a8";

      //todo correct positions
      switch (point.pointDirection) {
        case "lefttop":
          ctx.wrapText(
            dstring,
            renderPos.x - offset.width + tLen,//- (tLen + cornerMargin) * config.scale / config.defaultScale,
            renderPos.y - (fontSize + cornerMargin) * config.scale / config.defaultScale, mtext, fontSize
          );
          break;
        case "righttop":
          ctx.wrapText(
            dstring,
            renderPos.x + cornerMargin * config.scale / config.defaultScale,
            renderPos.y - (fontSize + cornerMargin) * config.scale / config.defaultScale, mtext, fontSize
          );
          break;
        case "rightbottom":
          ctx.wrapText(
            dstring,
            renderPos.x + (fontSize + cornerMargin) * config.scale / config.defaultScale,
            renderPos.y + (fontSize + cornerMargin) * config.scale / config.defaultScale, mtext, fontSize
          );
          break;
        case "leftbottom":
          ctx.wrapText(
            dstring,
            renderPos.x - (60 + cornerMargin) * config.scale / config.defaultScale,
            renderPos.y + (fontSize + cornerMargin) * config.scale / config.defaultScale,
            mtext, fontSize
          );
          break;
        default:
          ctx.wrapText(
            dstring,
            renderPos.x,
            renderPos.y - (fontSize / 2) + (fontSize * 2), mtext, fontSize
          );
          break;
      }
    }
  };
}
